import { TextField, Typography } from "@mui/material"

const WorkOrderCardWriteMessage = ({ values, handleChange, handleBlur, touched, errors, t }) => {
  return (
    <>
      <Typography pb={1} mt={2} variant="h6">
        {t("issuereports.message_to_workshop", "Message to workshop")}
      </Typography>
      <TextField
        p={2}
        placeholder={t("issuereports.workorder_information", "Work order information...")}
        minRows={3}
        multiline
        autoComplete="off"
        fullWidth
        id="message"
        value={values.message}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.message && errors.message ? true : false}
        helperText={touched.message && errors.message ? errors.message : null}
        variant="outlined"
        InputProps={{ disableUnderline: true }}
      />
    </>
  )
}

export default WorkOrderCardWriteMessage
